/* Block - Tab.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "./block-tab.scss";

const blockTabs = document.querySelectorAll('.block-tab');

blockTabs.forEach((blockTab) => {
    blockTabHeader(blockTab.id);
});

function blockTabHeader (blockId) {
    const headerTabs = document.querySelectorAll(`#${blockId} .block-tab__header-item`);
    const totalIndex = headerTabs.length - 1;
    let currentIndex = 0;

    const headerTabContents = document.querySelectorAll(`#${blockId} .block-tab__row`);
    const btnPrev = document.querySelector(`#${blockId} .block-tab__btn--prev`);
    const btnNext = document.querySelector(`#${blockId} .block-tab__btn--next`);

    btnNext.addEventListener('click', function () {
        if (currentIndex < totalIndex) {
            currentIndex++;
            removeActiveTabHeader(headerTabs);
            headerTabs[currentIndex].classList.add('block-tab__header-item--active');
            handleTabContent(headerTabContents, currentIndex);
        }
    });

    btnPrev.addEventListener('click', function () {
        if (currentIndex > 0) {
            currentIndex--;
            removeActiveTabHeader(headerTabs);
            headerTabs[currentIndex].classList.add('block-tab__header-item--active');
            handleTabContent(headerTabContents, currentIndex);
        }
    });

    headerTabs.forEach((tab) => {
        tab.addEventListener('click', function () {
            removeActiveTabHeader(headerTabs);
            this.classList.add('block-tab__header-item--active');
            handleTabContent(headerTabContents, this.dataset.index);
        });
    });
};

function removeActiveTabHeader (tabs) {
    tabs.forEach(tab => tab.classList.contains('block-tab__header-item--active') ? tab.classList.remove('block-tab__header-item--active') : null);
}

function handleTabContent (contents, index) {
    contents.forEach(content => {
        if (content.classList.contains('block-tab__row--active')) {
            content.classList.remove('block-tab__row--active');
            content.classList.remove('block-tab__row--transition');
        }
    });
    contents[index].classList.add('block-tab__row--active');
    setTimeout(() => contents[index].classList.add('block-tab__row--transition'), 100);
}
